import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Button } from "@components/Button";

interface IErrorProps {
  imageSrc?: string;
  title: string;
  description?: string;
  className?: string;
}

export const Error: React.FC<IErrorProps> = (props) => {
  const {
    imageSrc = "/images/common/error.png",
    title,
    description,
    className,
  } = props;

  const { t } = useTranslation();

  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center",
        className,
      )}
    >
      <img className="size-40" src={imageSrc} />
      <h1 className="pb-3">{title}</h1>
      {description && (
        <span className="max-w-sm text-center text-grey-dark">
          {description}
        </span>
      )}
      <Button
        className="mt-5 min-w-[140px]"
        onClick={() => {
          location.reload();
        }}
      >
        {t("common.tryAgain")}
      </Button>
    </div>
  );
};
